
export default function Hero() {
  return (
    <section className="relative h-[70vh] min-h-[600px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://static.readdy.ai/image/3b8ad55d4ff58d61aa412f5935e39846/1d3b9ccf43e603226e103140e0cc6884.jpeg')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 text-center w-full">
        <div className="inline-block bg-[#8B1538] text-white px-6 py-2 rounded-full text-sm font-bold mb-6 uppercase tracking-wider">
          Chrome Commodity Trading
        </div>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 font-['Montserrat']">
          PRODUCT <span className="text-[#8B1538]">MARKET</span>
        </h1>
        <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-['Lato'] leading-relaxed">
          South Africa&apos;s gateway to global chrome markets — connecting local resources with
          international demand
        </p>
        <div className="flex flex-wrap gap-4 justify-center mt-10">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-lg">
            <div className="text-3xl font-bold text-white">70%+</div>
            <div className="text-sm text-white/80">Global Chrome Reserves</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-lg">
            <div className="text-3xl font-bold text-white">Asia</div>
            <div className="text-sm text-white/80">Primary Export Market</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-lg">
            <div className="text-3xl font-bold text-white">Global</div>
            <div className="text-sm text-white/80">Client Reach</div>
          </div>
        </div>
      </div>
    </section>
  );
}
